<script lang="ts">
  type Item = { id: string; label: string };
  let {
    items = [],
    value = $bindable(''),
    placeholder = 'Buscar y seleccionar…',
    limit = 10,
    required = false,
    emptyLabel = '— Seleccionar —',
  }: {
    items?: Item[];
    value?: string;
    placeholder?: string;
    limit?: number;
    required?: boolean;
    emptyLabel?: string;
  } = $props();

  let q = $state('');
  let open = $state(false);

  const seleccionado = $derived(items.find(i => i.id === value));
  const filtrados = $derived.by(() => {
    const t = q.trim().toLowerCase();
    const list = t ? items.filter(i => i.label.toLowerCase().includes(t)) : items;
    return list.slice(0, limit);
  });

  function elegir(id: string) {
    value = id;
    q = '';
    open = false;
  }
</script>

<div class="ss">
  <input
    type="search"
    {placeholder}
    {required}
    value={open ? q : (seleccionado?.label ?? '')}
    onfocus={() => { open = true; q = ''; }}
    oninput={(e) => { open = true; q = (e.currentTarget as HTMLInputElement).value; }}
    autocomplete="off"
  />
  {#if open}
    <ul>
      <li><button type="button" onclick={() => elegir('')}>{emptyLabel}</button></li>
      {#each filtrados as it (it.id)}
        <li><button type="button" class:on={it.id === value} onclick={() => elegir(it.id)}>{it.label}</button></li>
      {:else}
        <li class="empty">Sin coincidencias (máx. {limit})</li>
      {/each}
    </ul>
  {/if}
</div>

<style>
  .ss { position: relative; min-width: 180px; }
  input {
    width: 100%; box-sizing: border-box;
    padding: 0.5rem 0.65rem; border: 1px solid #e5e7eb; border-radius: 8px;
    font: inherit; background: #fff; color: #111827;
  }
  input:focus { outline: none; border-color: #16a34a; box-shadow: 0 0 0 3px rgba(22,163,74,0.12); }
  ul {
    position: absolute; z-index: 20; left: 0; right: 0; margin: 0.15rem 0 0; padding: 0.25rem 0;
    list-style: none; background: #fff; border: 1px solid #e5e7eb; border-radius: 8px;
    max-height: 220px; overflow: auto; box-shadow: 0 8px 24px rgb(0 0 0 / 8%);
  }
  button {
    display: block; width: 100%; text-align: left; border: 0; background: none;
    padding: 0.4rem 0.7rem; font: inherit; cursor: pointer; color: #111827;
  }
  button:hover, button.on { background: #f0fdf4; color: #166534; }
  .empty { padding: 0.45rem 0.7rem; color: #9ca3af; font-size: 0.82rem; }
</style>
